module.exports = __webpack_public_path__ + "img/manchester-united.2faccc23.png";